/**
 * Defines the types of navigation actions available in the application.
 *
 * Use these constants to distinguish between updating page content dynamically
 * (without a full reload) and performing a full page redirect to a new URL.
 */
export default class PageNavigationAction {
  /**
   * Action type for dispatching a location fetch.
   * This action typically updates the current page content without a full reload.
   */
  static get updateLocation() {
    return this.getInstance('updateLocation');
  }

  /**
   * Action type for redirecting to a page.
   * This action performs a full page reload to the specified URL.
   */
  static get redirectToPage() {
    return this.getInstance('redirectToPage');
  }

  /**
   * Gets an instance of PageNavigationAction based on the provided key.
   * If an instance with the same key already exists, it returns that instance.
   * Otherwise, it creates a new instance and stores it for future use.
   * @param {string} key - The key representing the navigation action.
   * @returns {PageNavigationAction} An instance of PageNavigationAction.
   */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new PageNavigationAction(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  /**
   * Converts the location type to a string representation.
   * @returns {string} The string representation of the location type.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(PageNavigationAction, 'instances', { value: {} });